/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Typography } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import React, { useMemo, useState } from 'react'

import { getEntityName, getRoleFromStorage } from '../../helpers/userData'
import { getTranslate, lang } from '../../localization'
import { InventoryChannelType, NumberFieldData } from '../../mockData/inventory'
import {
  MenuItemInInventory,
  ProviderAddon,
  RatePlanForChannelInventory
} from '../../types/inventory'
import { typeOfMenuItems } from './InventoryRateplanRow'
import InventoryRowMenu from './InventoryRowMenu'
import RenderRowValues from './renderRows/RenderRowValues'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface InventoryChannelRowProps {
  channelData: RatePlanForChannelInventory[]
  channelName: string
  occupancy: number | 'def'
  selectedInventoryFieldInChannel: MenuItemInInventory
  handleChangeSelectedInventoryFieldInChannel: (
    fieldType: MenuItemInInventory
  ) => void
  weekendIndexes: number[]
  onSaveRowData?: (rowData: InventoryChannelType) => void
  availability: NumberFieldData[]
  displayRatePlanCode: string
  hideZeroes: boolean
  range: 'TWO_WEEKS' | 'MONTH'
  defaultOccupancy: number
  addOns: ProviderAddon[]
}

const InventoryChannelRow: React.FC<InventoryChannelRowProps> = ({
  channelData,
  selectedInventoryFieldInChannel,
  handleChangeSelectedInventoryFieldInChannel,
  channelName,
  weekendIndexes,
  onSaveRowData,
  availability,
  hideZeroes,
  displayRatePlanCode,
  occupancy,
  defaultOccupancy,
  range,
  addOns
}) => {
  const classes = useStyles()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showChannels, setshowChannels] = useState(false)

  const menuItems: MenuItemInInventory[] = useMemo(
    () =>
      Object.keys(channelData[0].dataForEachDate[0])
        .filter(
          (item) => !['name', 'channels', 'date', 'addOns'].includes(item)
        )
        .map((item) => ({
          label: item,
          code: item,
          type: typeOfMenuItems(item) as 'boolean' | 'number' | 'price'
        }))
        .concat({
          label: getTranslate('discountPercentage'),
          code: 'discountPercentage',
          type: 'number'
        })
        .concat(
          addOns.map((addon) => ({
            label:
              lang == 'fa'
                ? addon.nameTranslatedList.find(
                    (name) => name.label === 'Iran, Islamic Republic of'
                  )?.value || ''
                : addon.name,
            code: addon.code,
            type: 'price'
          }))
        ),
    []
  )

  return (
    <div
      className={[
        classes.channelRow,
        range === 'MONTH' ? classes.channelRowRowForMonth : ''
      ].join(' ')}>
      <div className={classes.rowNameContainer}>
        <div className={classes.roomIcon} />
        <div className={[classes.rowName, classes.channelName].join(' ')}>
          <Typography variant="h5">
            {getRoleFromStorage().includes('CHANNEL')
              ? getEntityName()
              : channelName}
          </Typography>
        </div>
      </div>
      <div className={classes.dayContainer}>
        <InventoryRowMenu
          items={menuItems}
          onChangeSelectedItem={(newMenuItem) =>
            handleChangeSelectedInventoryFieldInChannel(
              newMenuItem as MenuItemInInventory
            )
          }
          activeItem={selectedInventoryFieldInChannel.label}
        />
        <ArrowRightIcon
          className={[
            classes.channelArrowRight,
            classes.channelArrowRightCollapsed
          ].join(' ')}
        />
      </div>
      <RenderRowValues
        // maxValues={
        //   selectedInventoryFieldInChannel === 'allocatedAvail'
        //     ? availability
        //     : undefined
        // }
        defaultOccupancy={defaultOccupancy}
        hideZeroes={hideZeroes}
        rowData={
          channelData.find(
            (channeldata) =>
              channeldata.basicDetails.displayRatePlanCode ===
              displayRatePlanCode
          )?.dataForEachDate
        }
        selectedInventoryField={selectedInventoryFieldInChannel}
        {...{
          weekendIndexes
        }}
        occupancy={occupancy}
        // onSaveRowData={(newRowData) =>
        //   onSaveRowData(newRowData as InventoryChannelType)
        // }
      />
    </div>
  )
}

export default InventoryChannelRow
